import wx from "weixin-js-sdk";
const wxShare = function (id) {
    //option是分享的配置内容*/
    const url = window.location.href.split("#")[0]; //获取当前的url
	//const url = window.location.href; //获取当前的url
	this.request.postURL("/api/activity/shareGroupH5",{	
			id:id,
			url:url,
	})
	.then(res=>{
			var option={
				shareTitle:res.data.data.name,
				shareUrl:window.location.href,
				shareDesc:res.data.data.title,
				shareImg:res.data.data.icon,
			}	
        wx.config({
            debug: false, //是否开启debug
            appId: res.data.data.appid,//你的appid
            timestamp: res.data.data.timestamp, //时间戳
            nonceStr: res.data.data.noncestr,//随机字符串
            signature: res.data.data.signature,//秘钥（秘钥生成规则请看我另一篇文章（php获取微信AccessToken，生成秘钥））
            jsApiList: [ //请求的api接口列表
                    'updateAppMessageShareData',
                    'updateTimelineShareData',
					'onMenuShareAppMessage',
					'onMenuShareTimeline',
					"getLocation"
            ],		
        });
        wx.ready(function () { //如果wx.config配置正常，会自动走此处
			// 发送给朋友
			wx.updateAppMessageShareData({
                title: option.shareTitle,//分享的标题
                desc: option.shareDesc,//分享的简介
                link: option.shareUrl,//分享的url
                imgUrl: option.shareImg,//分享的图片
				success:function(){
					
				},
				fail:function(){
					// alert("分享失败")
				}
            });
			//分享朋友圈
			wx.updateTimelineShareData({
			    title: option.shareTitle,//分享的标题
			    desc: option.shareDesc,//分享的简介
			    link: option.shareUrl,//分享的url
			    imgUrl: option.shareImg,//分享的图片
				success:function(){
					
				},
				fail:function(){
					// alert("分享失败")
				}
			});
        });
        wx.error(function (res) { //如果wx.config配置失败,会走到此处
			
        })
	
    });

};

export default wxShare //将此方法导出
